const colors = {
	tprimary: '#e9c05f',
	tsecondary: '#1e1e1e',
	ttertiary: '#ba8023',
};

export default colors;
